import { render, staticRenderFns } from "./AddPartnerTimetable.vue?vue&type=template&id=6b1fe38f&"
import script from "./AddPartnerTimetable.vue?vue&type=script&lang=js&"
export * from "./AddPartnerTimetable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports